export const portalApps = [
  {
    slug: "odoo-success-plans",
    name: "Odoo Plans",
    eyebrow: "Implementation",
    description: "Compare five Odoo implementation packages, consultant hours, deliverables, and pricing in English and Arabic.",
    route: "/odoo-success-plans",
    icon: "requests",
  },
  {
    slug: "licensing",
    name: "SanRack Licensing",
    eyebrow: "Lifetime Licenses",
    description: "Manage customers, computer codes, permanent activation keys, payments, and license history in Supabase. Administrator access required.",
    route: "/portal/apps/licensing",
    source: "/apps/license-manager.html",
    icon: "license",
  },
  {
    slug: "data-center-survey",
    name: "Data Center Survey",
    eyebrow: "Audit Hub",
    description: "Capture site, power, cooling, fire, and readiness details for data center survey work.",
    route: "/portal/apps/data-center-survey",
    source: "/apps/data-center-survey-tool.html",
    icon: "database",
  },
  {
    slug: "dcf-sizing-tool",
    name: "DCF Sizing Tool",
    eyebrow: "Engineering Calculator",
    description: "Run frontend-only facility sizing calculations for power, UPS, generator, cooling, and compliance checks.",
    route: "/portal/apps/dcf-sizing-tool",
    source: "/apps/dcf-sizing-tool-v2-final.html",
    icon: "chart",
  },
  {
    slug: "sanaya-files",
    name: "Sanaya Files",
    eyebrow: "Private Drive",
    description: "Open protected company folders, files, previews, uploads, and document collaboration tools.",
    route: "/sanaya-files",
    icon: "folder",
  },
  {
    slug: "academy-upload",
    name: "Academy Upload",
    eyebrow: "Learning Manager",
    description: "Manage Academy sections, playlists, YouTube lessons, notes, publishing, and resource links.",
    route: "/portal/academy-upload",
    icon: "academy",
  },
  {
    slug: "service-requests",
    name: "Service Requests",
    eyebrow: "Operations",
    description: "Review package requests, update follow-up status, add internal notes, and export request records.",
    route: "/portal/service-requests",
    icon: "requests",
  },
];
